import { handleApiError } from "../../utils/handleApiError";
import api from "../axios";

const getAccountId = () => {
  return sessionStorage.getItem("acc_id");
};

const getUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

export const getPatientOutOfRangeStats = async (_, sourceURL) => {
  const user = getUser();
  const account_id = getAccountId();
  const location_id = JSON.parse(sessionStorage.getItem("current_loc"))?.id;

  try {
    let url;
    if (user?.account_role?.name === "Case Manager") {
      url = `/patients/${account_id}/${user?.staff_id}/staff-patients/`;
    } else if (
      user?.account_role?.name === "Super User" &&
      window.location.pathname === "/admin-case-manager/escalated-review" &&
      !sourceURL
    ) {
      url = `/patients/${account_id}/patients/?type=all`;
    } else if (user?.account_role?.name === "Super User") {
      url = `/patients/${account_id}/${location_id}/patients/`;
    }

    let patients;
    // full list (this stat reads all patients from sessionStorage; the endpoint
    // paginates by default now). axios appends pagination=false to any URL branch.
    const response = await api.get(url, { params: { pagination: "false" } });

    if (user?.account_role?.name === "Case Manager") {
      patients = response.data?.assigned_patients;
    } else {
      patients = response?.data?.patients;
    }

    const totalPatients = response.data?.patient_count || patients.length;

    // Filter out-of-range patients
    const outOfRangePatients = patients.filter((p) => p.out_of_range);

    // Calculate percentages
    const outOfRangeCount = outOfRangePatients.length;
    const outOfRangePercent =
      totalPatients > 0
        ? Math.round((outOfRangeCount / totalPatients) * 100)
        : 0;
    const completionPercent = totalPatients > 0 ? 100 - outOfRangePercent : 0;

    // Store data
    sessionStorage.setItem("all_patients", JSON.stringify(patients)); // complete list
    sessionStorage.setItem(
      "out_of_range_patients",
      JSON.stringify(outOfRangePatients)
    ); // out of range only
    sessionStorage.setItem("completion_percentage", completionPercent.toString());

    return {
      patients,
      totalPatients,
      outOfRangeCount,
      outOfRangePercent,
      completionPercent,
      outOfRangePatients,
    };
  } catch (error) {
    console.error("Error fetching patient statistics:", error);
    return {
      totalPatients: 0,
      outOfRangeCount: 0,
      outOfRangePercent: 0,
      completionPercent: 0,
      patients: [],
      outOfRangePatients: [],
    };
  }
};

export const getCompletionPercentage = () => {
  try {
    const percentage = sessionStorage.getItem("completion_percentage");
    return percentage ? Number.parseInt(percentage, 10) : 0;
  } catch (error) {
    console.error("Error getting completion percentage:", error);
    return 0;
  }
};

export const getOutOfRangeReadings = async (patientId) => {
  const account_id = getAccountId();
  const response = await api.get(
    `/rpm/${account_id}/readings/${patientId}/?filter=1week&only_out_of_range=true`
  );
  return response.data;
};

export const updateReadingStatus = async (patientId, payload) => {
  const account_id = getAccountId();

  try {
    const response = await api.post(
      `/rpm/${account_id}/readings-review-escalate/${patientId}/`,
      payload
    );

    return { success: true, data: response.data };
  } catch (error) {
    handleApiError(error);
    return {
      success: false,
      error: error.response?.data?.message || "Failed to update reading status",
    };
  }
};

export const SendEmailToProvider = async (format, data) => {
  const account_id = getAccountId();
  const response = await api.post(
    `/rpm/${account_id}/email_filtered_readings/${format}/`,
    data
  );

  return response.data;
};

export const getAllPatients = async () => {
  const account_id = getAccountId();
  // const location_id = JSON.parse(sessionStorage.getItem("current_loc"))?.id

  const response = await api.get(`/patients/${account_id}/patients/?type=all`);
  return response.data;
};

// export const getPatientReadings = async (
//   account_id,
//   patientId,
//   filterType = "all"
// ) => {
//   try {
//     if (!tenant || !patientId) {
//       console.error("Missing tenant or patientId");
//       return { readings: [] };
//     }

//     let url = `/rpm/${tenant}/readings/${patientId}/?`;

//     if (filterType === "all") {
//       url += "out_of_range=true";
//     } else if (filterType === "escalated") {
//       url += "out_of_range=true&escalated=true";
//     } else if (filterType === "reviewed") {
//       url += "reviewed=true&out_of_range=true";
//     }

//     const response = await api.get(url);
//     return response.data;
//   } catch (error) {
//     handleApiError(error);
//     return { readings: [] };
//   }
// };

export const getAllPatientReadings = async (filter) => {
  try {
    const account_id = getAccountId();

    const response = await api.get(
      `/rpm/${account_id}/readings/?out_of_range=true&filter=${filter}`
    );
    const allReadings = response.data?.readings;

    return allReadings || [];
  } catch (error) {
    handleApiError(error);
    return [];
  }
};
